import React, { useState, useRef, useEffect, useMemo } from "react";
// import { useDocuments } from "../../../../components/Onboarding/onboardingHooks/useDocuments";
import { useUserFieldData } from "../../../../components/Onboarding/onboardingHooks/useUserFieldData";
import { DocumentPreview } from "../../../../components/Onboarding/document/DocumentPreview";
import { DocumentEditor } from "../../../../components/Onboarding/document/DocumentEditor";
import { ApplicantFillView } from "../../../../components/Onboarding/workflow/ApplicantFillView";
import { ApproverReviewView } from "../../../../components/Onboarding/workflow/ApproverReviewView";
import { DocumentDrawer } from "../../../../components/Onboarding/drawer/DocumentDrawer";
import { downloadPDF } from "../../../../components/Onboarding/onboardingUtils/pdfGenerator";
// import { pdfBufferStore } from "../../../../components/Onboarding/onboardingUtils/pdfBufferStats";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  showToast,
  TableAdv,
} from "../../../../components";
import { dataService } from "../../../../components/Onboarding/services/dataService";
import { InitiatorFillView } from "../../../../components/Onboarding/workflow/InitiatorFillView";
import {
  addPdfTemplate,
  fetchPdfTemplates,
  updatePdfTemplate,
} from "../../../../redux/slices/onboarding/onboardingApi";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import {
  onboardingDocumentCategory,
  onboardingDocumentType,
} from "../../../../assets/data/enumData";
import { dateFormator } from "../../../../utils";
import { usePagination } from "../../../../hooks";
import { getPresignedUrl } from "../../../../redux/slices/universal/fileUploadApi";

const emptyDocument = () => ({
  id: "",
  referenceId: "",
  documentName: "",
  category: "",
  type: "",
  description: "",
  toBeFilledBy: null,
  createdBy: "",
  createdOn: "",
  workflows: [],
  arrayBuffer: null,
  pages: [],
  pageCount: 0,
  droppedFields: {},
  status: "",
  isBlankDocument: false,
  sharedWith: [],
  buffer: [],
});

const DocumentSettings = ({ documentType }) => {
  console.log({ documentType });
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { page, limit, setPage, setLimit, handleLimitChange } =
    usePagination(25);
  const [view, setView] = useState("table");
  const [currentDocument, setCurrentDocument] = useState(emptyDocument());
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerStep, setDrawerStep] = useState("initial");
  const [pdftemplates, setPdftemplates] = useState({});
  console.log({ currentDocument, pdftemplates });
  const [documentForm, setDocumentForm] = useState({
    toBeFilledBy: documentType,
    documentName: "",
    category: "",
    type: "",
    description: "",
  });
  const [workflows, setWorkflows] = useState([
    { initiator: [], approvers: [] },
  ]);
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef(null);
  const [workflowTargetDoc, setWorkflowTargetDoc] = useState(null);
  const [currentUserId, setCurrentUserId] = useState("");
  const [currentUserRole, setCurrentUserRole] = useState("");
  const [selectedApplicant, setSelectedApplicant] = useState("");
  const [tempDocumentData, setTempDocumentData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);

  const {
    userFieldData,
    updateFieldValue,
    updateUserStatus,
    deleteDocumentData,
    getSubmittedApplicants,
  } = useUserFieldData();

  // useeffect for loading the documnets
  // useEffect(() => {
  //   const loadDocuments = async () => {
  //     try {
  //       setLoading(true);
  //       const docs = await dataService.getDocuments();
  //       setDocuments(docs || []);
  //     } catch (error) {
  //       console.error("Error loading documents:", error);
  //       setDocuments([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   loadDocuments();
  // }, []);

  // useeffect for saving the documents when they change
  useEffect(() => {
    if (!loading && documents.length >= 0) {
      const saveDocuments = async () => {
        try {
          await dataService.saveDocuments(documents);
        } catch (error) {
          console.error("Error saving documents:", error);
        }
      };
      const timer = setTimeout(saveDocuments, 500);
      return () => clearTimeout(timer);
    }
  }, [documents, loading]);

  // Filtering the documnetsbased on tab in which we are viewing
  const filteredDocuments = useMemo(() => {
    return documents.filter((doc) => doc.toBeFilledBy === documentType);
  }, [documents, documentType]);

  // useeffct to update the document form when documenttype changes
  useEffect(() => {
    setDocumentForm((prev) => ({
      ...prev,
      toBeFilledBy: documentType,
    }));
  }, [documentType]);

  //GETLPDFTEMPLATES:::::::fetch all the documents and display according to the documentType
  const fetchTemplates = async (documentType) => {
    try {
      setLoading(true);
      const res = await fetchPdfTemplates({
        limit: limit,
        page: page,
        filters: {
          filledBy: {
            type: "NONE",
            value: documentType,
          },
        },
        ref: "AddedBy Approver Initiator",
        incl: [
          "firstName lastName",
          "firstName lastName",
          "firstName lastName",
        ],
      });
      setPdftemplates({
        data: res?.data?.data || [],
        totalCount: res?.totalCount?.data,
        backup: res?.data?.data || [],
      });
    } catch (error) {
      console.error("error in fetchTemplates", error);
    } finally {
      setLoading(false);
    }
  };
  //use useEffect to fetch the data for pdf templates and to dispaly in the the tables
  useEffect(() => {
    fetchTemplates(documentType);
  }, [documentType, page, limit]);

  // const addDocument = (doc) => {
  //   setDocuments((prev) => [doc, ...prev]);
  // };

  const updateDocument = (id, updated) => {
    setPdftemplates(
      (prev) => ({
        ...prev,
        data: prev?.data?.map((d) =>
          d.uiid === id ? { ...d, ...updated } : d
        ),
      })
      // prev?.data?.map((d) => (d.uiid === id ? { ...d, ...updated } : d))
    );
  };

  const updateDocumentName = async (id, name) => {
    const oldValue =
      pdftemplates?.backup?.find((d) => d.uiid === id)?.name || "";
    if (name === oldValue) {
      showToast("Nothing To Change", "info");
      return;
    }
    try {
      const updatePayloadWorkflow = [
        {
          type: "SET",
          value: {
            name,
          },
        },
      ];
      // return;
      const res = await updatePdfTemplate({
        coll: "PdfTemplate",
        uiid: id,
        payload: updatePayloadWorkflow,
      });
      console.log({ res });
      if (res.success) {
        showToast("Updated Document Name Successfully", "success");
      } else {
        updateDocument(id, { name: oldValue });
        showToast("Updating Document Name Failed", "error");
      }
    } catch (e) {
      updateDocument(id, { name: oldValue });
      showToast("Something Went Wrong", "error");
      console.error("Error in the updateDocumentName", e);
    }
  };

  const deleteDocumentLocal = (id) => {
    setDocuments((prev) => prev.filter((d) => d.id !== id));
    deleteDocumentData(id);
  };

  const resetDrawerState = () => {
    setDrawerStep("initial");
    setDocumentForm({
      toBeFilledBy: documentType,
      documentName: "",
      category: "",
      type: "",
      description: "",
    });
    setWorkflows([{ initiator: null, approvers: null }]);
    setIsProcessing(false);
    setTempDocumentData(null);
    setWorkflowTargetDoc(null);
  };

  const handleFileProcess = (file, pdfData = null) => {
    if (pdfData && pdfData.isBlankDocument) {
      setTempDocumentData(pdfData);
      return;
    }
    if (!file && !pdfData) return;
    if (pdfData) {
      setTempDocumentData(pdfData);
    }
  };

  const handleDrawerClose = () => {
    resetDrawerState();
    setDrawerOpen(false);
  };

  const handleDrawerProceed = () => {
    if (drawerStep === "upload") {
      if (
        !documentForm.documentName ||
        !documentForm.category ||
        !documentForm.type
      ) {
        alert("Please fill all required fields");
        return;
      }
      setDrawerStep("workflow");
    } else if (drawerStep === "workflow") {
      if (currentDocument?.uiid) {
        handleSaveFromDrawer(documentForm, workflows, true);
      } else {
        handleSaveFromDrawer(documentForm, workflows);
      }
    }
  };

  const handleSkipWorkflow = () => {
    if (workflowTargetDoc) {
      resetDrawerState();
      setDrawerOpen(false);
      return;
    }
    handleSaveFromDrawer(documentForm, []);
  };

  const handleSaveFromDrawer = async (
    documentForm,
    workflows,
    workflowUpdate = false
  ) => {
    try {
      setLoading(true);
      if (!workflowUpdate) {
        const docId = tempDocumentData?.tempId || Date.now().toString();

        const newDoc = {
          id: docId,
          referenceId: `DOC-${Date.now()}`,
          documentName: documentForm.documentName || "Untitled",
          category: documentForm.category || "General",
          type: documentForm.type || "Other",
          description: documentForm.description || "",
          toBeFilledBy: documentForm.toBeFilledBy || 1,
          createdBy: `Current User_${Date.now()}`,
          createdOn: new Date().toISOString(),
          workflows: workflows || [],
          arrayBuffer: tempDocumentData?.arrayBuffer || null,
          pages: tempDocumentData?.pages || [],
          pageCount: tempDocumentData?.pageCount,
          droppedFields: {},
          status: "active",
          isBlankDocument: tempDocumentData?.isBlankDocument || false,
        };
        //disable this 👇👇 to stop adding in the local storage
        // addDocument(newDoc);
        //
        const createPayload = new FormData();
        const payload = {
          templateId: newDoc?.referenceId,
          filledBy: newDoc?.toBeFilledBy,
          name: newDoc?.documentName,
          entity: newDoc?.toBeFilledBy,
          category: newDoc?.category,
          type: newDoc?.type,
          status: 2,
          description: newDoc?.description,
          pageCount: newDoc?.pageCount,
          ...(newDoc?.workflows?.[0]?.approvers?.value && {
            approver: newDoc?.workflows?.[0]?.approvers?.value,
          }),
          ...(newDoc?.workflows?.[0]?.initiator?.value && {
            initiator: newDoc?.workflows?.[0]?.initiator?.value,
          }),
          addedBy: loginUserUiid,
        };
        Object.entries(payload).forEach(([k, v]) => {
          createPayload.append(`payload[${k}]`, v);
        });
        createPayload.append("coll", "PdfTemplate");
        const blob = new Blob([newDoc.arrayBuffer], {
          type: "application/pdf",
        });
        createPayload.append("doc", blob);
        const res = await addPdfTemplate(createPayload);
        if (res.success) {
          fetchTemplates(documentType);
          resetDrawerState();
          setDrawerOpen(false);
          setView("table");
        } else {
          showToast("Something Wengt Wrong While Adding!", "error");
          throw new Error(
            "handleSaveFromDrawer ::::::Something Wengt Wrong While Adding! :::::::: res.success is false"
          );
        }
      } else {
        //to update the drawer button for updating the workflow pdf templates
        const updatePayloadWorkflow = [
          {
            type: "SET",
            value: {
              ...(workflows?.[0]?.approvers?.value && {
                approver: workflows?.[0]?.approvers?.value,
              }),
              ...(workflows?.[0]?.initiator?.value && {
                initiator: workflows?.[0]?.initiator?.value,
              }),
            },
          },
        ];
        // return;
        const res = await updatePdfTemplate({
          coll: "PdfTemplate",
          uiid: currentDocument?.uiid,
          payload: updatePayloadWorkflow,
        });
        console.log("workflows for updatye", workflows, res);
        if (res.success) {
          showToast("Updated Workflow Successfully", "success");
          fetchTemplates(documentType);
          resetDrawerState();
          setDrawerOpen(false);
          setView("table");
        } else {
          showToast("Updating Workflow Failed", "error");
          throw Error("Updating Workflow Failed with updatePdfTemplate");
        }
      }
    } catch (error) {
      setLoading(false);
      showToast("Something Wengt Wrong While Adding!", "error");
      console.error("Error in the handleSaveFromDrawer", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApproverDecision = (decision, applicantId) => {
    updateUserStatus(currentDocument.id, applicantId, decision, {
      approver: currentUserId,
      approvedAt: new Date().toISOString(),
    });
    alert(`Application ${decision}!`);
    setView("table");
    setCurrentDocument(emptyDocument());
    setCurrentUserId("");
    setCurrentUserRole("");
    setSelectedApplicant("");
  };

  const handleDocumentActions = async (doc, mode = "preview") => {
    try {
      console.log({ doc });
      if (!doc?.file) {
        showToast("No File Found!", "error");
        return;
      }
      setLoading(true);
      const presignedUrl = await getPresignedUrl(doc?.file);
      const response = await fetch(presignedUrl, {
        mode: "cors",
      });
      const urlDataInBlob = await response.blob();
      const arrayBuffer = await urlDataInBlob.arrayBuffer();

      const newDoc = {
        id: doc.uiid,
        referenceId: doc.templateId,
        documentName: doc.name,
        category: doc.category,
        type: doc.type,
        description: doc.description,
        toBeFilledBy: doc.filledBy,
        createdBy: `${doc?.addedBy?.firstName} ${doc?.addedBy?.lastName}`,
        createdOn: doc.addedOn,
        workflows: [
          {
            approvers: { label: doc.approver, value: doc.approver },
            initiator: { label: doc.initiator, value: doc.initiator },
          },
        ],
        arrayBuffer,
        pageCount: doc.pageCount,
        droppedFields: doc?.fields || {}, //doc.fields,
        status: doc.status,

        // sharedWith: [],
        // buffer: [],
        // file: doc.file,
      };
      switch (mode) {
        case "preview": {
          setCurrentDocument(newDoc);
          setView(mode);
          return;
        }
        case "editor": {
          setCurrentDocument(newDoc);
          setView(mode);
          return;
        }
      }
    } catch (error) {
      console.error("Error in handleDocumentActions", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleEditDocument = (doc) => {
  //   setCurrentDocument(doc);
  //   setView("editor");
  // };

  const handleUpdateField = (fieldId, value, userId = null) => {
    const targetUserId = userId || currentUserId;
    updateFieldValue(currentDocument.id, targetUserId, fieldId, value);
  };

  const handleSaveInitiatorData = () => {
    const initiatorFields = Object.values(currentDocument.droppedFields || {})
      .flat()
      .filter((f) => f.role === "initiator" && f.required);

    const hasEmpty = initiatorFields.some(
      (field) =>
        !userFieldData[currentDocument.id]?.[currentUserId]?.[field.id] ||
        String(
          userFieldData[currentDocument.id][currentUserId][field.id]
        ).trim() === ""
    );

    if (hasEmpty) {
      alert("Please fill all required initiator fields.");
      return;
    }

    updateUserStatus(currentDocument.id, currentUserId, "initiator-submitted", {
      role: "initiator",
      submittedAt: new Date().toISOString(),
    });
    alert("Initiator data has been saved!");
    setView("table");
    setCurrentDocument(emptyDocument());
    setCurrentUserId("");
    setCurrentUserRole("");
  };

  const handleSaveApplicantData = () => {
    const applicantFields = Object.values(currentDocument.droppedFields || {})
      .flat()
      .filter((f) => f.role === "applicant" && f.required);

    const hasEmpty = applicantFields.some(
      (field) =>
        !userFieldData[currentDocument.id]?.[currentUserId]?.[field.id] ||
        String(
          userFieldData[currentDocument.id][currentUserId][field.id]
        ).trim() === ""
    );

    if (hasEmpty) {
      alert("Please fill all required applicant fields.");
      return;
    }

    updateUserStatus(currentDocument.id, currentUserId, "applicant-submitted", {
      role: "applicant",
      submittedAt: new Date().toISOString(),
    });
    alert("Applicant data saved! Ready for approver review.");
    setView("table");
    setCurrentDocument(emptyDocument());
    setCurrentUserId("");
    setCurrentUserRole("");
  };

  const handleSaveApproverData = () => {
    const approverFields = Object.values(currentDocument.droppedFields || {})
      .flat()
      .filter((f) => f.role === "approver" && f.required);

    const hasEmpty = approverFields.some(
      (field) =>
        !userFieldData[currentDocument.id]?.[currentUserId]?.[field.id] ||
        String(
          userFieldData[currentDocument.id][currentUserId][field.id]
        ).trim() === ""
    );

    if (hasEmpty) {
      alert("Please fill all required approver fields.");
      return;
    }

    updateUserStatus(currentDocument.id, currentUserId, "approver-submitted", {
      role: "approver",
      submittedAt: new Date().toISOString(),
    });
    alert("Approver data saved and document approved!");
    setView("table");
    setCurrentDocument(emptyDocument());
    setCurrentUserId("");
    setCurrentUserRole("");
  };

  const handleCloneDocument = (doc) => {
    const clonedDoc = {
      ...doc,
      id: Date.now().toString(),
      referenceId: `DOC-${Date.now()}`,
      documentName: `${doc.documentName} (Copy)`,
      createdOn: new Date().toISOString(),
    };

    const originalIndex = filteredDocuments.findIndex((d) => d.id === doc.id);
    const allDocsIndex = documents.findIndex((d) => d.id === doc.id);

    setDocuments((prev) => {
      const newDocs = [...prev];
      newDocs.splice(allDocsIndex + 1, 0, clonedDoc);
      return newDocs;
    });
  };

  const handleDownloadDocument = async (doc) => {
    // await downloadPDF(doc);
    try {
      setLoading(true);
      const presignedUrl = await getPresignedUrl(doc?.file);
      const response = await fetch(presignedUrl, {
        mode: "cors",
      });
      const urlDataInBlob = await response.blob();
      const link = document.createElement("a");
      const objectUrl = URL.createObjectURL(urlDataInBlob);
      link.href = objectUrl;
      link.download = `${doc?.name} - ${doc?.templateId}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up blob URL
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      setLoading(false);
      console.error("Error in handleDownloadDocument for pdftemplates", error);
      showToast("Download Failed!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleInitiator = async (updatedDocument) => {
    await handleSaveFromEditor(updatedDocument);
  };

  const handleSaveFromEditor = async (updatedDocument) => {
    try {
      setLoading(true);
      const updatePayload = [
        {
          type: "SET",
          value: {
            _skipFlatten: ["fields"],
            fields: updatedDocument?.droppedFields || {},
          },
        },
      ];
      const res = await updatePdfTemplate({
        coll: "PdfTemplate",
        uiid: updatedDocument?.id,
        payload: updatePayload,
      });
      if (res.success) {
        fetchTemplates(documentType);
        setView("table");
        setCurrentDocument(emptyDocument());
      } else {
        showToast("Updating Failed!", "error");
        throw new Error("res.success is false in updatePdfTemplate api");
      }
    } catch (error) {
      console.error("Error in handleSaveFromEditor", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDocument = (docId) => {
    if (!window.confirm("Delete document?")) return;
    deleteDocumentLocal(docId);
  };

  const handleApplicantFill = (doc) => {
    const userId = prompt("Enter your email/name:");
    if (!userId || !userId.trim()) return;
    const workflowApplicants =
      doc.workflows?.map((w) => w.applicant?.trim()).filter(Boolean) || [];
    const sharedUsers = doc.sharedWith || [];
    const isAuthorized =
      workflowApplicants.includes(userId.trim()) ||
      sharedUsers.includes(userId.trim());
    if (!isAuthorized) {
      alert(
        "Access denied. You are not authorized to fill this document.\n\n" +
          "This document can only be filled by:\n" +
          "- Applicants listed in the workflow\n" +
          "- Users with whom the document has been shared"
      );
      return;
    }
    setCurrentUserId(userId.trim());
    setCurrentUserRole("applicant");
    setCurrentDocument(doc);
    setView("applicant-fill");
  };

  const handleApproverReview = (doc) => {
    const approverId = prompt("Enter your approver email/name:");
    if (!approverId || !approverId.trim()) return;

    const hasWorkflows = doc.workflows && doc.workflows.length > 0;

    if (hasWorkflows) {
      const workflowApprovers =
        doc.workflows.flatMap((w) =>
          (w.approvers || []).map((a) => String(a).trim()).filter(Boolean)
        ) || [];

      const isAuthorized = workflowApprovers.includes(approverId.trim());
      if (!isAuthorized) {
        alert(
          "Access denied. You are not listed as an approver for this document.\n\n" +
            "Authorized approvers:\n" +
            workflowApprovers.map((a) => `- ${a}`).join("\n")
        );
        return;
      }
    }

    const applicants = getSubmittedApplicants(doc.id);
    if (applicants.length === 0) {
      alert("No applicants have submitted data for this document yet.");
      return;
    }

    setCurrentUserId(approverId.trim());
    setCurrentUserRole("approver");
    setSelectedApplicant(applicants[0]);
    setCurrentDocument(doc);
    setView("approver-review");
  };

  const handleInitiatorFill = (doc) => {
    const initiatorId = prompt("Enter your initiator email/name:");
    if (!initiatorId || !initiatorId.trim()) return;
    setCurrentUserId(initiatorId.trim());
    setCurrentUserRole("initiator");
    setCurrentDocument(doc);
    setView("initiator-fill");
  };

  const handleShareDocument = (doc) => {
    const userId = prompt("Enter user email/name to share with:");
    if (!userId || !userId.trim()) return;
    const existingData = userFieldData[doc.id]?.[userId];
    if (existingData && Object.keys(existingData).length > 0) {
      if (
        !window.confirm(
          "This user already has data for this document. Create new entry?"
        )
      ) {
        return;
      }
    }
    updateUserStatus(doc.id, userId, "pending", {
      role: "applicant",
      createdAt: new Date().toISOString(),
    });
    updateDocument(doc.id, {
      sharedWith: [...(doc.sharedWith || []), userId],
    });
    alert(
      `Document shared with ${userId}. They can now fill the applicant fields.`
    );
  };

  const handleConfigureWorkflow = (doc) => {
    setCurrentDocument(doc);
    console.log("handleConfigureWorkflow", doc);
    if (doc) {
      setWorkflowTargetDoc(doc);
      setDocumentForm({
        toBeFilledBy: doc.toBeFilledBy || 1,
        documentName: doc.documentName || "",
        category: doc.category || "",
        type: doc.type || "",
        description: doc.description || "",
      });
      // setWorkflows(
      //   doc.workflows && doc.workflows.length > 0
      //     ? doc.workflows
      //     : [{ initiator: null, approvers: null }],
      // );
      setWorkflows([
        {
          initiator: {
            label: `${doc?.initiator?.firstName || ""} ${
              doc?.initiator?.lastName || ""
            }`,
            value: doc?.initiator?.uiid || "",
          },
          approvers: {
            label: `${doc?.approver?.firstName || ""} ${
              doc?.approver?.lastName || ""
            }`,
            value: doc?.approver?.uiid || "",
          },
        },
      ]);
      setDrawerStep("workflow");
    } else {
      setWorkflowTargetDoc(null);
      setDocumentForm({
        toBeFilledBy: documentType,
        documentName: "",
        category: "",
        type: "",
        description: "",
      });
      setWorkflows([{ initiator: null, approvers: null }]);
      setDrawerStep("initial");
    }
    setDrawerOpen(true);
  };

  const handleWorkflowSubmit = ({ action, remarks, applicantId }) => {
    const docId = currentDocument.id;
    const targetUserId =
      action === "approve" || action === "reject" ? applicantId : currentUserId;

    // Get required fields based on current role
    const requiredFields = Object.values(currentDocument.droppedFields || {})
      .flat()
      .filter((f) => f.role === currentUserRole && f.required);

    // Validate required fields
    const hasEmpty = requiredFields.some(
      (field) =>
        !userFieldData[docId]?.[currentUserId]?.[field.id] ||
        String(userFieldData[docId][currentUserId][field.id]).trim() === ""
    );

    if (hasEmpty && action !== "reject") {
      alert(`Please fill all required ${currentUserRole} fields.`);
      return;
    }

    // Handle different actions
    switch (action) {
      case "submit": {
        const statusMap = {
          initiator: "initiator-submitted",
          applicant: "applicant-submitted",
          approver: "approver-submitted",
        };

        updateUserStatus(docId, currentUserId, statusMap[currentUserRole], {
          role: currentUserRole,
          submittedAt: new Date().toISOString(),
        });

        alert(
          `${
            currentUserRole.charAt(0).toUpperCase() + currentUserRole.slice(1)
          } data saved successfully!`
        );
        break;
      }

      case "approve":
      case "reject": {
        // Store remarks
        updateFieldValue(docId, applicantId, "_approver_remarks", remarks);

        // Update status
        updateUserStatus(
          docId,
          applicantId,
          action === "approve" ? "approved" : "rejected",
          {
            approver: currentUserId,
            approvedAt: new Date().toISOString(),
            remarks,
          }
        );

        alert(`Application ${action}ed!`);
        break;
      }
    }

    setView("table");
    setCurrentDocument(null);
    setCurrentUserId("");
    setCurrentUserRole("");
    setSelectedApplicant("");
  };

  const getInitiatorId = () => {
    if (!currentDocument) return null;

    const initiators = currentDocument.workflows
      ?.map((w) => {
        if (Array.isArray(w.initiator) && w.initiator.length > 0) {
          return String(w.initiator[0]).trim();
        }
        return null;
      })
      .filter(Boolean);

    return initiators?.length > 0 ? initiators[0] : null;
  };

  const tableColumns = [
    {
      key: "documentName",
      label: "Document Name",
      columnMenu: false,
      render: (row) => (
        <div className="flex gap-2 items-center">
          {editingId === row.uiid ? (
            <FormFieldSet
              value={row.name}
              noTitle
              size="sm"
              onChange={(value) => updateDocument(row.uiid, { name: value })}
            />
          ) : (
            row.name
          )}
          <Button
            type="icon"
            icon={editingId === row.uiid ? "save" : "edit_square"}
            // onClick={
            //   editingId === row.uiid
            //     ? () => setEditingId(editingId === row.uiid ? null : row.uiid)
            //     : () => alert("skjuhbs")
            // }
            onClick={async () => {
              if (editingId === row.uiid) {
                await updateDocumentName(row.uiid, row.name); // you need this logic
                setEditingId(null);
              } else {
                setEditingId(row.uiid);
              }
            }}
            variant="text"
            size="xs-sm"
            color="black"
          />
        </div>
      ),
    },
    {
      key: "referenceId",
      label: "Reference ID",
      columnMenu: false,
      render: (row) => row?.templateId || "",
    },
    {
      key: "category",
      label: "Category",
      columnMenu: false,
      render: (row) =>
        onboardingDocumentCategory?.find((a) => a?.value === row?.category)
          ?.label || "-",
    },
    {
      key: "type",
      label: "Type",
      columnMenu: false,
      render: (row) =>
        onboardingDocumentType?.find((a) => a?.value === row?.type)?.label ||
        "-",
    },
    {
      key: "createdBy",
      label: "Created By",
      columnMenu: false,
      render: (row) =>
        (row?.addedBy?.firstName || "") + " " + (row?.addedBy?.lastName || ""),
    },
    {
      key: "createdOn",
      label: "Created On",
      columnMenu: false,
      render: (row) => dateFormator(row.addedOn),
    },
    {
      key: "actions",
      label: "Actions",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleDocumentActions(row, "preview")}
            icon="visibility"
            size="sm"
          />
          <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleDocumentActions(row, "editor")}
            icon="brush"
            size="sm"
          />
          {/* <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleInitiatorFill(row)}
            icon="person"
            size="sm"
          /> */}
          <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleConfigureWorkflow(row)}
            icon="person_add"
            size="sm"
          />
          {/* <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleShareDocument(row)}
            icon="send"
            size="sm"
          /> */}
          {/* <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleApplicantFill(row)}
            icon="edit_note"
            size="sm"
          /> */}
          {/* <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleApproverReview(row)}
            icon="check_circle"
            size="sm"
          /> */}
          <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleDownloadDocument(row)}
            icon="download"
            size="sm"
          />
          {/* <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => {
              console.log("=== DOCUMENT DEBUG ===");
              console.log("Document ID:", row.id);
              console.log("Buffer in store:", pdfBufferStore.get(row.id));
              console.log("Buffer in doc:", row.arrayBuffer);
              console.log("BufferBytes in doc:", row.bufferBytes);
              console.log("Dropped fields:", row.droppedFields);
              console.log("Number of pages:", row.pages?.length);
            }}
            icon="bug_report"
            size="sm"
          /> */}
          <Button
            type="icon"
            variant="text"
            color="black"
            onClick={() => handleCloneDocument(row)}
            icon="content_copy"
            size="sm"
            disabled
          />
          <Button
            type="icon"
            variant="text"
            color="black"
            // onClick={() => handleDeleteDocument(row.id)}
            icon="delete"
            size="sm"
            disabled
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-1">
      {view === "table" && (
        <div className="flex-1 flex flex-col p-2">
          <TableAdv
            columns={tableColumns}
            rows={pdftemplates?.data || []}
            showSlNo={false}
            showCheckbox={false}
            serverPagination={true}
            totalCount={pdftemplates?.totalCount || 0}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            tableId={"documents-table"}
            toolbarRight={{
              filter: true,
              add: [
                {
                  component: (
                    <Button
                      title="Create Document"
                      icon="add"
                      color="primary"
                      variant="contained"
                      size="sm"
                      onClick={() => handleConfigureWorkflow(null)}
                    />
                  ),
                },
              ],
            }}
          />
        </div>
      )}

      {view === "preview" && currentDocument && (
        <DocumentPreview
          document={currentDocument}
          mode="preview"
          onBack={() => {
            setView("table");
            setCurrentDocument(null);
          }}
          onEdit={() => setView("editor")}
        />
      )}

      {view === "editor" && currentDocument && (
        <DocumentEditor
          document={currentDocument}
          onSave={handleSaveFromEditor}
          onBack={() => {
            setView("table");
            setCurrentDocument(emptyDocument());
          }}
        />
      )}

      {view === "initiator-fill" && currentDocument && (
        <DocumentPreview
          document={currentDocument}
          mode="initiator"
          userId={currentUserId}
          userRole="initiator"
          userFieldData={
            userFieldData[currentDocument.id]?.[currentUserId] || {}
          }
          onUpdateField={handleUpdateField}
          onSubmit={handleWorkflowSubmit}
          onBack={() => {
            setView("table");
            setCurrentDocument(null);
            setCurrentUserId("");
            setCurrentUserRole("");
          }}
        />
      )}

      {view === "applicant-fill" && currentDocument && (
        <DocumentPreview
          document={currentDocument}
          mode="applicant"
          userId={currentUserId}
          userRole="applicant"
          userFieldData={
            userFieldData[currentDocument.id]?.[currentUserId] || {}
          }
          initiatorData={
            userFieldData[currentDocument.id]?.[getInitiatorId()] || {}
          }
          onUpdateField={handleUpdateField}
          onSubmit={handleWorkflowSubmit}
          onBack={() => {
            setView("table");
            setCurrentDocument(null);
            setCurrentUserId("");
            setCurrentUserRole("");
          }}
        />
      )}

      {view === "approver-review" && currentDocument && (
        <DocumentPreview
          document={currentDocument}
          mode="approver"
          userId={currentUserId}
          userRole="approver"
          selectedApplicant={selectedApplicant}
          onSelectApplicant={setSelectedApplicant}
          applicants={getSubmittedApplicants(currentDocument.id)}
          userFieldData={
            userFieldData[currentDocument.id]?.[currentUserId] || {}
          }
          initiatorData={
            userFieldData[currentDocument.id]?.[getInitiatorId()] || {}
          }
          applicantData={
            userFieldData[currentDocument.id]?.[selectedApplicant] || {}
          }
          onUpdateField={handleUpdateField}
          onSubmit={handleWorkflowSubmit}
          onDownload={() => handleDownloadDocument(currentDocument)}
          onBack={() => {
            setView("table");
            setCurrentDocument(null);
            setCurrentUserId("");
            setCurrentUserRole("");
            setSelectedApplicant("");
          }}
        />
      )}

      <DocumentDrawer
        open={drawerOpen}
        step={drawerStep}
        documentForm={documentForm}
        workflows={workflows}
        isProcessing={isProcessing}
        fileInputRef={fileInputRef}
        documentType={documentType}
        onClose={handleDrawerClose}
        onStepChange={setDrawerStep}
        onDocumentFormChange={setDocumentForm}
        onWorkflowsChange={setWorkflows}
        onFileProcess={handleFileProcess}
        onProceed={handleDrawerProceed}
        onSkipWorkflow={handleSkipWorkflow}
        setIsProcessing={setIsProcessing}
        workflowTargetDoc={workflowTargetDoc}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default DocumentSettings;
